import * as service from './service'
export default {
  namespace: 'recommendUserUserRecommendRecord',
  state: {
    demoData: {}
  },
  effects: {
    * getRecommendList ({ payload }, { call, put }) {
      const res = yield call(service.getRecommendList, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
